import axios from 'axios';
import get from 'lodash.get';
import { INVITE_REQUEST_VALUES } from '../fulfillment-providers/constants';

export const accept3PLInvite = (inviteToken, clientName) => axios.post('/fulfillmentDelegation/accept', { inviteToken, clientName });

export const send3PLClientInvite = (invite) => axios.post('/fulfillmentDelegation/v2/invite', invite);

export const get3PLClients = (showInactive) => axios.get(`/fulfillmentDelegation/clients?showInactive=${showInactive}`);

export const cancelPendingClient = (externalInviteId) => axios.delete(`/fulfillmentDelegation/cancel/${externalInviteId}`);

export const resendClientInvite = (externalInviteId, invite) => {
  return axios
    .post(`/fulfillmentDelegation/v2/invite/resend/${externalInviteId}`, {
      inviteDirection: INVITE_REQUEST_VALUES.PARTNER_TO_CLIENT,
      inviteType: INVITE_REQUEST_VALUES.CLIENT_3PL,
      recipientEmail: invite.recipientEmail,
      recipientName: invite.recipientName,
      senderName: invite.senderName,
    })
    .then((response) => response.data);
};

export const deactivateClient = (externalClientConnectionId) => {
  return axios
    .post('fulfillmentDelegation/partner/deactivate', {
      externalClientConnectionId,
    })
    .then((response) => response.data);
};

export const deactivateMarketplace = (storeId) => {
  return axios
    .post('fulfillmentDelegation/partner/deactivate/store', {
      storeId,
    })
    .then((response) => response.data);
};

export const getFulfillmentServices = async (fulfillmentProviderId) => {
  try {
    const request = await axios.get(`/fulfillmentDelegation/v2/servicenames/${fulfillmentProviderId}`);
    const result = get(request, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error getting fulfillment services data : ${error?.message}`);
  }
};
